export const website = {
  bg: "grey",
  borderRadius: "square",
};
